module.exports = {
	"menu": [
		{
			"desc": "图标管理",
			"path": "icon"
		},
		{
			"desc": "下拉框",
			"path": "select"
		},
		{
			"desc": "按钮",
			"path": "button"
		},
		{
			"desc": "输入框",
			"path": "input"
		},
		{
			"desc": "复选框",
			"path": "checkbox"
		},
		{
			"desc": "单选框",
			"path": "radio"
		},
		{
			"desc": "分页",
			"path": "pagination"
		},
		{
			"desc": "区块组件",
			"path": "section"
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ./example/config.json
// module id = 134
// module chunks = 0